import { getContactByStatus, getContacts, getContactsByStatus, getDefaultContact, storeContact } from '@/api/contacts';

import { ref } from 'vue';

export default function useContacts() {
  const contact = ref({});
  const contacts = ref([]);
  const currentContact = ref([]);

  const fetchContacts = async () => {
    const fetchedContacts = await getContacts();
    contacts.value = fetchedContacts;
  };

  const fetchContactsByStatus = async (status) => {
    let fetchedContacts = await getContactsByStatus(status);

    if (fetchContacts.data.length === 0) {
      const fetchedDefaultContact = await getDefaultContact();
      contacts.value = fetchedDefaultContact.data;
    } else {
      contacts.value = fetchedContacts.data;
    }
  };

  const fetchContactByStatus = async (status) => {
    let fetchedContact = await getContactByStatus(status);

    if (!fetchedContact) {
      const fetchedDefaultContact = await getDefaultContact();
      contact.value = fetchedDefaultContact.data;
    } else {
      contact.value = fetchedContact;
    }
  };

  return {
    contact,
    contacts,
    currentContact,
    fetchContactByStatus,
    fetchContacts,
    fetchContactsByStatus,
    storeContact,
  };
}
